import { render } from "./Lists.vue?vue&type=template&id=9dafd182"
import script from "./Lists.vue?vue&type=script&lang=ts"
export * from "./Lists.vue?vue&type=script&lang=ts"
script.render = render

export default script